import React from 'react';
import cls from 'classnames';
import './FormControlLabel.css';

interface FormControlLabelProps extends React.HTMLAttributes<HTMLDivElement> {
  control: React.ReactElement<any, any>;
  label: React.ReactNode;
}
export const FormControlLabel: React.FC<FormControlLabelProps> = ({
  className,
  control,
  label,
  ...props
}) => (
  <div className={cls(className, 'lb_formControlLabel')} {...props}>
    {React.cloneElement(control)}
    <span>{label}</span>
  </div>
);
